import { Link } from "react-router-dom";
 
 function CartWishlist(){ 
  return( 
    <>
      <div className="box-wishlist">
            <div className="link-Rottaion">
                <Link to="/wishlist"> 
                        <i className="bi bi-heart"></i>
                        <div className="badge-danger"> 0 </div>
                </Link>
            </div>
        </div>
    </>
    )
    }
export default CartWishlist; 